/*********************** Custom JS for Boost AI Search & Discovery  ************************/
// if(boostSDAppConfig){
//   if(boostSDAppConfig?.filterSettings) {
//   boostSDAppConfig.filterSettings.filterAvoidStickyHeader = ['header.site-header', 'announcement-bar .swiper']; 
// }

// if (boostSDAppConfig?.searchSettings) {  
//    boostSDAppConfig.searchSettings.suggestionMobileStyle = 'style2';
// }

// }

if (document.body.classList.contains('template-search')) {
  if(document.querySelector('.boost-sd__sorting') && document.querySelector('.boost-sd__sorting').innerHTML == ''){
    document.querySelector('.boost-sd__sorting').innerHTML = 'Sort by';
  }  
}
setTimeout(() => {
  const stickyDiv = document.querySelector('.boost-sd__toolbar-top-mobile');
  const stickyDivOuter = document.querySelector('.boost-sd__toolbar-item.boost-sd__toolbar-item--sorting');
  function handleStickyDiv() {
    console.log("sticky scroll");
    if(stickyDivOuter){
      var scrollPosition = window.scrollY;
      var stickyDivOffset = stickyDivOuter.getBoundingClientRect().top + window.scrollY;
      // console.log('stickyDivOffset', stickyDiv.getBoundingClientRect().top);
      if (scrollPosition > stickyDivOffset) {
        stickyDiv.classList.add('filter-sticky');
        // stickyDiv.style.position = 'fixed';
        // stickyDiv.style.top = '0';
      } else {
        stickyDiv.classList.remove('filter-sticky');
        // stickyDiv.style.position = 'static';
      }
    }
    
  }
  window.addEventListener('scroll', handleStickyDiv);
  // handleStickyDiv();
}, 2000);
console.log('loadeddddd');
document.addEventListener('DOMContentLoaded',()=>{
  setTimeout(()=>{
    document.querySelectorAll('.boost-sd__product-label').forEach(function(label) {
    // console.log('label', label);
    const span = label.querySelector('.boost-sd__product-label-text');
    // if (span) {
    //   const value = span.textContent.trim().toLowerCase().replace(/\s+/g, '-');
    //   label.classList.add(`label-${value}`);
    // }
  });
},3000);
})









